import { TitleCasePipe } from '@angular/common';

// Same table markup as getSkippedTripsHtml (auto-distribution / trips-distribution modals),
// extended with an optional Reason column, a custom message and custom column labels.
export function getSkippedItemsHtml(skippedItems: any[], message: string, showReason = true, labels = ['Member', 'Reference ID']): string {
  const th = 'sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap';
  const td = 'px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap';
  let html = `<p class="mb-4">${message}</p><div
    class="max-h-[400px] overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                  <th class="${th}">${labels[0]}</th>
                  <th class="${th}">${labels[1]}</th>
                  ${showReason ? `<th class="${th}">Reason</th>` : ''}
                </tr>
              </thead>
              <tbody>`;
  (skippedItems || []).forEach((item: any) => {
    const member = item?.data?.member;
    const name = member?.displayName || [member?.firstName, member?.lastName].filter(Boolean).join(' ');
    html += `
                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                  <td class="${td}">${name ? new TitleCasePipe().transform(name) : ''}</td>
                  <td class="${td}">${item?.data?.reference ?? 'N/A'}</td>
                  ${showReason ? `<td class="${td}">${item?.reason ?? ''}</td>` : ''}
                </tr>`;
  });
  html += `
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>`;
  return html;
}
